
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/classrooms",
      function () {
        return require("private-next-pages/classrooms/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/classrooms"])
      });
    }
  